import { onMounted, onUnmounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { toast } from 'dashboard/helper/toast';

// Mantém a pausa do store em dia com o servidor. Chamado UMA vez, na barra
// superior (sempre montada no dashboard):
// - carrega os motivos da conta (menu de pausa e nomes no relatório);
// - pausa que não saiu desta aba (outra aba, "Ocupado" puro pelo menu,
//   supervisor): o motivo e o início só existem no servidor — busca depois de
//   o job gravar o período;
// - saiu de Ocupado por qualquer caminho: limpa.
const SERVER_SETTLE_MS = 3000;

export function useAgentPauseSync() {
  const { t } = useI18n();
  const store = useStore();
  const availability = useMapGetter('getCurrentUserAvailability');
  const accountId = useMapGetter('getCurrentAccountId');
  const uiFlags = useMapGetter('agentPauses/getUIFlags');

  let syncTimer = null;

  const sync = async () => {
    try {
      await store.dispatch('agentPauses/syncCurrentPause');
    } catch {
      toast.error(t('AGENT_PAUSE.BAR.SYNC_ERROR'));
    }
  };

  const fetchReasons = async () => {
    try {
      await store.dispatch('agentPauses/fetchReasons');
    } catch {
      toast.error(t('AGENT_PAUSE.REASONS.FETCH_ERROR'));
    }
  };

  watch(availability, value => {
    clearTimeout(syncTimer);
    if (value !== 'busy') {
      store.dispatch('agentPauses/clearCurrentPause');
      return;
    }
    // Pausa feita aqui mesmo já pôs motivo e início no store.
    if (uiFlags.value.isChangingPause) return;
    syncTimer = setTimeout(sync, SERVER_SETTLE_MS);
  });

  // Troca de conta: motivos e pausa são por conta.
  watch(accountId, () => {
    store.dispatch('agentPauses/clearCurrentPause');
    fetchReasons();
    if (availability.value === 'busy') sync();
  });

  onMounted(() => {
    fetchReasons();
    if (availability.value === 'busy') sync();
  });

  onUnmounted(() => clearTimeout(syncTimer));
}
